import * as React from 'react';
const SvgQuiz = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 26 26" fill="none" {...props}>
        <path d="M4 6a2 2 0 012-2h4.182a2 2 0 012 2v4.182a2 2 0 01-2 2H6a2 2 0 01-2-2V6z" fill="#90C3FF" />
        <path
            d="M4 14.679c0-.476.386-.862.861-.862a7.32 7.32 0 017.321 7.321.861.861 0 01-.861.861H6a2 2 0 01-2-2v-5.32z"
            fill="#FD8878"
        />
        <path d="M13.818 6a2 2 0 012-2H20a2 2 0 012 2v4.182a2 2 0 01-2 2h-4.182a2 2 0 01-2-2V6z" fill="#54C3D2" />
        <path
            d="M13.818 15.817a2 2 0 012-2H20a2 2 0 012 2V20a2 2 0 01-2 2h-4.182a2 2 0 01-2-2v-4.182z"
            fill="#FDDA46"
        />
        <rect x={1} y={1} width={24} height={23.999} rx={3} stroke="#DEDFE0" strokeWidth={2} />
    </svg>
);
export default SvgQuiz;
